import { Component, inject } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { MatButtonModule } from '@angular/material/button';

interface DialogData {
  image: string | null;
  title: string;
  message: string;
  buttonText: string;
  expirationTime?: Date | null;
}

// Deliberately NOT wrapped in <cm-ui-dialog> — see docs/ui-modules.md § cm-ui-dialog. This
// dialog is opened with `disableClose: true` for the forced-logout (inactivity) case, and
// cm-ui-dialog's header always renders a close (X) button that calls `dialogRef.close()`
// unconditionally (CDK's `disableClose` only suppresses ESC/backdrop-click dismissal, not a
// programmatic `.close()` call) — adding it here would let a user dismiss a security-driven
// forced logout without acknowledging it. Its own bespoke template (no title bar, single
// action button) is kept as-is; only the DI tokens move to CDK's dialog so this still works
// when opened via CmUiDialogService.
@Component({
  selector: 'app-inactivity-modal',
  standalone: true,
  imports: [MatButtonModule],
  templateUrl: './inactivity-modal.component.html',
  styleUrls: ['./inactivity-modal.component.scss'],
})
export class InactivityModalComponent {
  dialogRef = inject<DialogRef<string, InactivityModalComponent>>(DialogRef);
  data = inject<DialogData>(DIALOG_DATA);

  goToLogin(): void {
    this.dialogRef.close('login');
  }
}
